@if (invoice(); as invoice) {
  <div class="container">
    {{ `${DictionaryCode.INVOICE_TYPE}.${invoice.defaultType}` | translate }}

    @if (invoice.collectiveInvoiceIssueTerm) {
      <app-contractor-invoice-collective-issue-term
        class="f-muted"
        [invoice]="invoice"
      ></app-contractor-invoice-collective-issue-term>
    }
  </div>
} @else {
  -
}
